import { render, staticRenderFns } from "./DetailAutorization.vue?vue&type=template&id=e3ed7c2c"
import script from "./DetailAutorization.js?vue&type=script&lang=js&external"
export * from "./DetailAutorization.js?vue&type=script&lang=js&external"
import style0 from "./DetailAutorization.vue?vue&type=style&index=0&id=e3ed7c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports